const determineManualOrder = () => {
  if (window) {
    return (
      window.manualOrderToken &&
      window.isManualOrder &&
      window.manualOrderSettings
    );
  }
  return false;
};

export { determineManualOrder };



// WEBPACK FOOTER //
// ./utils/ManualOrderUtils.js